import axios from "axios";

const env = false;
const clienteAxios = axios.create({
  baseURL: env ? "http://localhost:5500/" : "https://api.bladelink.company/",
});

export default clienteAxios;
